import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import LatestNewSection from "./components/LatestNewSection";
import ClientsSection from "./components/ClientsSection";
import OtherNewsSection from "./components/OtherNewsSection";
import SpeechesSection from "./components/SpeechesSection";
import Youtube from "./components/Youtube";
import MissionVission from "./components/MissionVission";
import PhotoNewsSection from "./components/PhotoNewsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FeaturedSection from "./components/FeaturedSection";
import FaqSection from "./components/FaqSection";
import ContactSection from "./components/ContactSection";
import FeedbackFromNigeriansSection from "./components/FeedbackFromNigeriansSection";
import PublicAnnounceSection from "./components/PublicAnnounceSection";
import TopManagementSection from "./components/TopManagementSection";
import LiveStream from "./components/LiveStream";
import Loading from "../../components/admin/childComponents/appComponents/Loading";
//import AccordionSection from "./components/AccordionSection";

function HomePage(props) {
  const { section, id, albumId } = useParams();

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [homeData, setHomeData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    setLoading(true);

    fetchHomePage(id, controller.signal);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    return () => controller.abort();
  }, [section, id]);

  const fetchHomePage = async (ID, signal) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_URL}homepage-data?pageName[eq]=${ID ?? 1}`,
        { signal },
      );

      setHomeData(response?.data?.data || {});
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  //console.log("$$$444", homeData?.speeches);
  if (loading) return <Loading message01="Loading..." />;
  const isHome = section === "Home" || section === undefined;
  return (
    <>
      {homeData?.latestNews?.length > 0 && (
        <LatestNewSection
          datacontent={homeData?.latestNews || []}
          initialPagination={homeData?.latestNewsPagination || {}}
          id={id ?? 1}
        />
      )}

      {isHome && <TestimonialsSection />}

      {homeData?.otherNews?.length > 0 && (
        <OtherNewsSection
          datacontent={homeData?.otherNews || []}
          initialPagination={homeData?.otherNewsPagination || {}}
          id={id ?? 1}
          type={1}
        />
      )}

      {isHome && <MissionVission />}

      {homeData?.speeches?.length > 0 && (
        <SpeechesSection
          datacontent={homeData?.speeches || []}
          initialPagination={homeData?.speechesPagination || {}}
          id={id ?? 1}
        />
      )}

      {homeData?.publicAnnouncement?.length > 0 && (
        <PublicAnnounceSection
          datacontent={homeData?.publicAnnouncement || []}
          initialDownloadData={homeData?.downloads || []}
          initialPagination={homeData?.publicAnnouncementPagination || {}}
          id={id ?? 1}
        />
      )}

      {(section === "F.A.Q" || Number(id) === 38) && <FaqSection />}

      {(section === "News & Media" || Number(id) === 23) && (
        <OtherNewsSection
          datacontent={homeData?.newsMedia || []}
          initialPagination={homeData?.newsMediaPagination || {}}
          type={2}
        />
      )}

      {homeData?.topManagement?.length > 0 && (
        <TopManagementSection
          datacontent={homeData?.topManagement || []}
          initialPagination={homeData?.topManagementPagination || {}}
          id={id ?? 1}
          section={props.section}
        />
      )}

      {(section === "Live Stream Event" || Number(id) === 57) && <LiveStream />}

      {(section === "Feedback  From Nigerians" || Number(id) === 56) && (
        <FeedbackFromNigeriansSection
          initialDownloadData={homeData?.downloads || []}
          initialSideNewsData={homeData?.sideNews || []}
          initialAdvertData={homeData?.advert || []}
        />
      )}

      {(section === "Contact" || Number(id) === 4) && (
        <ContactSection captcha={props.captcha} />
      )}

      {(section === "Photo Gallery" || Number(id) === "12") && (
        <PhotoNewsSection albumId={albumId} />
      )}
    </>
  );
}

export default HomePage;
